export default {
  meta: {
    title: '个人踩点统计报表（一鸣）'
  }
};
